import { styled } from '@mui/system';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

interface SignatureEditorProps {
  field: ControllerRenderProps<FieldValues, 'signatureBody'>;
}
const SignatureEditorComponent = styled('div')({
  minHeight: '200px',
  border: '1px #7E84AA solid',
  borderRadius: '4px',
});

const SignatureEditor = ({ field }: SignatureEditorProps) => {
  return (
    <SignatureEditorComponent
      contentEditable="true"
      dangerouslySetInnerHTML={{ __html: field.value }}
      onInput={(e) => {
        field.onChange(e.currentTarget.innerHTML);
      }}
    ></SignatureEditorComponent>
  );
};

export default SignatureEditor;
